import { EmptyClientsComponent } from './EmptyClientsComponent';
import { useOrganizationClients } from './useClients';
import { Table } from 'shared/ui/Table/TableBlocks';
import { useMemo, useState } from 'react';
import {
  ContentCotainer,
  ContentLoadingState,
} from 'shared/ui/layouts/PageContent';
import { EditClientModal } from './EditClientModal';
import { Drawer } from 'antd';
import { DetailSection } from '../../../shared/components';

const MyClientsPage = () => {
  const { clients, isFetching, isPending } = useOrganizationClients();
  const [clientToEdit, setClientToEdit] = useState(null);
  const [viewClientDetails, setViewClientDetails] = useState(null);

  const _getRowActions = (row) => {
    const actions = [
      {
        label: 'Edit Client Details',
        onClick: () => {
          setClientToEdit(row);
        },
      },
    ];

    if (
      row.clientOrganizationDetails?.paymentRequestLinks &&
      row.clientOrganizationDetails?.paymentRequestLinks.length &&
      row.clientOrganizationDetails?.paymentRequestLinks[0].url
    ) {
      actions.push({
        label: 'Request Payment',
        onClick: () => {
          const newWindow = window.open(
            row.clientOrganizationDetails.paymentRequestLinks[0].url,
            '_blank',
            'noopener,noreferrer'
          );
          if (newWindow) newWindow.opener = null;
        },
      });
    }

    return actions;
  };

  const columns = useMemo(
    () => [
      {
        header: 'Client Name',
        cell: ({ row: { original: item } }) => (
          <div className="font-medium text-white">{item.name}</div>
        ),
      },
      {
        header: 'Billing Email',
        cell: ({ row: { original: item } }) => item.billingEmail || item.email,
      },
      {
        header: 'Address',
        cell: ({ row: { original: item } }) => {
          const addressLine = `${item?.address?.streetAddress || ''}${
            item?.address?.country ? `, ${item?.address?.country}` : ''
          }`;

          return addressLine || '--';
        },
      },
      {
        header: 'actions',
      },
    ],
    []
  );

  if (isPending) {
    return <ContentLoadingState />;
  }

  return (
    <ContentCotainer>
      {clients?.length === 0 && !isFetching ? (
        <EmptyClientsComponent />
      ) : (
        <Table
          title="Clients"
          description="Access and manage your clients here."
          data={clients}
          columns={columns}
          isDataLoading={isFetching}
          getRowActions={_getRowActions}
          onRowClick={setViewClientDetails}
        />
      )}

      <EditClientModal
        client={clientToEdit}
        onClose={() => {
          setClientToEdit(null);
        }}
      />

      <Drawer
        closable
        destroyOnClose
        width={540}
        zIndex={10}
        title={'Client Details'}
        placement="right"
        open={!!viewClientDetails}
        loading={isPending}
        onClose={() => {
          setViewClientDetails(null);
        }}>
        {viewClientDetails && (
          <ClientDetails
            client={viewClientDetails}
            onEditClient={() => {
              setClientToEdit(viewClientDetails);
              setViewClientDetails(null);
            }}
          />
        )}
      </Drawer>
    </ContentCotainer>
  );
};

const ClientDetails = ({ client, onEditClient }) => {
  return (
    <div className="relative flex-1 space-y-6">
      <DetailSection header="Actions">
        <DetailSection.Item term="Change">
          <button
            className="font-medium text-indigo-400 hover:text-indigo-300"
            onClick={onEditClient}>
            Edit Client
          </button>
        </DetailSection.Item>
      </DetailSection>
    </div>
  );
};

export default MyClientsPage;
